import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, IonInfiniteScroll, LoadingController, ModalController, ToastController } from '@ionic/angular';
import { CalendarModalOptions } from 'ion2-calendar';
import { ServicesProvider } from 'src/providers/services';
import { AdvanceFilterPage } from '../advance-filter/advance-filter.page';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { InViewportMetadata } from 'ng-in-viewport';
import { DatePipe } from '@angular/common';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { AddCall } from 'src/providers/addvCall';
import * as CryptoJS from 'crypto-js';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}

@Component({
  selector: 'app-physiotherapy',
  templateUrl: './physiotherapy.page.html',
  styleUrls: ['./physiotherapy.page.scss'],
})
export class PhysiotherapyPage implements OnInit {
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');

  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  presentView: string;
  showAll1: boolean;
  // love: boolean;
  test: any = "id";
  home: boolean;
  direct: boolean;
  chApMntPopUpPro: boolean;
  editNamePpUp: boolean;
  PatientName: string;
  apMntQueue: boolean;
  apMntAddFltrPopUp: boolean;
  getReviewPopUp: boolean;
  backValue: string;
  headerValue: string;
  placeholderValue: string;
  sunMode: boolean = false;
  darkMode: boolean = false;
  Male: boolean = false;
  Female: boolean = false;
  physiotherapyes: any[];
  proTimeSlot: any[];
  appoinmentType: string;
  payBtnValue: string;
  playVid: any;
  ProfileVideo: any;
  totalSkeleten: any = [];
  minutes: any;
  seconds: any;
  isConfirmed : boolean

  curntDate: any;
  //calender

  dateInfo: any;
  date: string;
  year: string;
  month: string;
  day: string;
  dateRange: {
    from: Date;
    to: Date
  }


  //-----------API integretion Variabel------------//
  specialityList: any;
  storePhysiotherapyDocList: any = [];
  showMoreSlots: any;
  costSortingStatus: boolean = false;
  costSortingContent: string = "ASC";
  searchStatus: boolean = false;
  SearchContent: String = null;
  specialityId: any;
  genderStatus: boolean = false;
  genderContent: string = null;
  toastMessage: string;
  storeDocListIndex: any;
  advanceFilterStatus: boolean = false;
  advanceFilterCost: any = 0;
  advanceFilterOffers: any = 0;
  advanceFilterDistance: any = 0;
  particularDocterPro: any;
  patientBasicDetails: any;
  storeDocServiceList: any;
  clearTimeOut: any;
  storeDocBookingList: any = [];
  showRefundPopUp: boolean;
  storeBookingId: any;
  selectSlotFromTime: any;
  storeSelectedSlot: any;
  selectedService: any;
  bookingHisList: any = [];
  bookingHisDetails: any;
  terms_and_condition_file: any;
  storeFilterDocList: any;
  storeFilterPatientList: any;
  getFltrPatientId: any;
  getFltrDocId: any;
  getFltrFromDate: any;
  getFltrToDate: any;
  searchDate: any;
  getSearchDate: any;
  storeBookOrRescheFlowValue: any;
  storeDocterId: any;
  storeClinicId: any;
  oldBookingId: any;
  storeRefreshEvent: any;
  pageNo: number = 1;
  checkSearchTrueOrFalse: boolean = false; //check appointment list Advance search active in active only 
  count: number = 0;
  videoOptions: any = [];
  showVideoOptins: boolean;
  likedPopUpStatus: boolean;
  dblClikedIndex: any;
  // changeApmntId: number;
  Date: any = new Date();
  EmptyData: any = null;
  selectedDate: any;
  nextCount: any;
  storeSlots: any = [];
  profileMediaDetails: any = [];
  currentVideoId: any;
  currentVideoIndex: any;
  getReviewCommands: any;
  serviceDuration: { hr: any; min: any; };
  storeAppointmentTypeId: any;
  showBkgDetail: boolean;
  reletionList: any;
  getMemName: any;
  getMemGender: any;
  getMemReletion: any;
  getMemHeight: any;
  getMemMobileNo: any;
  getMemWeight: any;
  getMemDob: any;
  Dob: any;
  membDOB: any;
  queueList: any = [];
  positionQueue: any;
  profileImage: any;
  bookingAmnt: any;
  getStrRating: any;
  getRemark: any;
  setRevDocImg: any;
  setRevDocName: any;
  setRevDocId: any;
  currentMemberId: any;
  rescheduledIsMember: any;
  doctorServiceFees: any;
  chApMntPopUpList: boolean;
  storePhysioListIndex: any;

  constructor(
    public router: Router,
    public alertCtrl: AlertController,
    private services: ServicesProvider,
    public loadingController: LoadingController,
    public toastController: ToastController,
    public modalCtrl: ModalController,
    private datePipe: DatePipe,
    public addCall: AddCall,
    private httpClient: HttpClient,
    private file: File,
    private fileOpener: FileOpener
  ) { }
  option = {
    slidesPerView: 2,
    centeredSlides: false,
    //loop: true,
    spaceBetween: -210,
    // autoplay:true,
  }
  ngOnInit() {
    //current date only//
    let date = new Date();
    let day = date.toLocaleString('en-us', { weekday: 'long' });
    console.log(day);
    let curntDate = new Date;
    let curntDate2 = String(curntDate).split(" ");
    this.year = curntDate2[3];
    this.month = curntDate2[1];
    this.day = day;
    //--------------------//

    //-----------skeleten loading-----------//
    this.totalSkeleten;
    for (let i = 1; i <= 30; i++) {
      this.totalSkeleten.push(i);
    }
    console.log(this.totalSkeleten);

    this.videoOptions = [{
      playMode: false,
      muteMode: false,
    }];
  }

  //-----------------\/---------calender typescript only------------\/------------//

  onChange($event) {
    console.log($event);
    this.dateInfo = $event;
    let item = this.dateInfo.from._d;
    let dateArray = String(item).split(" ");
    this.year = dateArray[3];
    this.month = dateArray[1];
    this.day = item.toLocaleString('en-us', { weekday: 'long' });
    console.log(dateArray[1] + "/" + dateArray[3]);
    console.log(item);
  }
  dateMulti: string[];
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsMulti: CalendarModalOptions = {
    pickMode: 'range',
    // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdays: [this.addCall.title411,this.addCall.title412,this.addCall.title413,this.addCall.title414,this.addCall.title415,this.addCall.title416,this.addCall.title417],
    disableWeeks: [5],
  };

  //-----------------/\---------calender typescript only------------/\------------//


  //--------------------------><-------------------><----------------------><----------------------><---------------------------//


  //------\/-------LOADING'S & PRE DEFINE FUNCTION'S----\/--------//

  doRefresh(event, page) {
    this.storeRefreshEvent = event;
    this.pageNo = 1;
    this.EmptyData = null;
    if (page == "listSpeciality") {
      this.showListCatPage();
    }
    else if (page == "listdocter") {
      this.storePhysiotherapyDocList = [];
      this.showListPhysiotherapy(this.specialityId);
    }
    else if (page == "listBooking") {
      this.checkSearchTrueOrFalse = false;
      this.bookingListPage();
      // this.showAppointmentListPage();
    }
    else if (page == "listBookingHis") {
      this.checkSearchTrueOrFalse = false;
      this.bookingHisPage();
      // this.showHistoryPage();
    }
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }
  async presentLoading() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      // duration: 5000
    });
    await loading.present();
    console.log('Loading dismissed!');
  }

  dismissLoader() {
    this.loadingController.dismiss();
  }
  async presentToast() {
    const toast = await this.toastController.create({
      message: this.toastMessage,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  async presentModal() {
    const modal = await this.modalCtrl.create({
      component: AdvanceFilterPage,
      cssClass: 'ModelConCSS'
    });
    modal.onDidDismiss()
      .then((data) => {
        const response = data;
        console.log(response);
        if (response.data != null) {
          console.log(response.data);
          this.advanceFilterStatus = true;
          this.advanceFilterCost = response.data.costValue;
          this.advanceFilterOffers = response.data.offers;
          this.advanceFilterDistance = response.data.distance;
          this.searchDate = response.data.selectedDate
          console.log(response.data.selectedDate);
          let date = new Date(this.searchDate);
          console.log("serachDate=>", date);
          this.Date = date;
          this.pageNo = 1;
          this.EmptyData = null;
          this.showListPhysiotherapy(this.specialityId);
        }
      });
    return await modal.present();
  }


  loadData(event, page) {
    console.log(event);
    console.log(this.pageNo);
    this.pageNo += 1;
    if (page == "listdocter") {
      console.log("List trainig center load more");
      this.showListPhysiotherapy(this.specialityId);
    }
    else if (page == "listBooking") {
      console.log("list booking page");
      if (this.checkSearchTrueOrFalse == false) {
        this.showAppointmentListPage();
        console.log("search is not Active");
      }
      else if (this.checkSearchTrueOrFalse == true) {
        console.log("search is Active");
        this.searchApnMnt();
      }

    }
    else if (page == "listBookingHis") {
      console.log("list booking His page");
      if (this.checkSearchTrueOrFalse == false) {
        console.log("search is not Active");
        this.showHistoryPage();
      }
      else if (this.checkSearchTrueOrFalse == true) {
        console.log("search is Active");
        this.searchApnMnt();
      }
    }
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    });
    await alert.present();
  }

  //------/\-------LOADING'S & PRE DEFINE FUNCTION'S-----/\-------//


  // -------------------><------------------><-------------------><--------------------------><------------------//


  //-------------\/--------SOME SPECIAL FUNCTION'S-----------\/-------------//

  doubleClick(count, index, docId) {
    this.count += Number(count);
    console.log(this.count);
    if (this.count == 1) {
      console.log("before");
      setTimeout(() => {
        this.count = 0;
        console.log("count reseted");
      }, 300);
    }
    console.log("AftresetTimeOut");
    if (this.count == 2) {
      this.like(index, docId);
      this.count = 0;
      this.dblClikedIndex = index;
      this.likedPopUpStatus = true;
      setTimeout(() => {
        this.likedPopUpStatus = false;
      }, 1000)
    }
  }

  like(i, doctorId) {
    console.log("index=>", i, "doc ID=>", doctorId);
    this.storePhysiotherapyDocList[i].favourite = !this.storePhysiotherapyDocList[i].favourite;
    let apiData = JSON.stringify({
      "doctorId": doctorId,
      "patientId": localStorage.getItem("patient_id"),
      "favourite": this.storePhysiotherapyDocList[i].favourite
    });
    console.log("send favrit Reqst=>", JSON.parse(apiData));
    this.services.postRequest("favouriteDoctorAddingandRemoving", apiData).subscribe(res => {
      console.log(res);
    });
    if (this.storePhysiotherapyDocList[i].favourite == true) {
      this.toastMessage = "Add to Favourite";
      this.presentToast()
    }
    else if (this.storePhysiotherapyDocList[i].favourite == false) {
      this.toastMessage = "Removed from Favourite";
      this.presentToast()
    }
  }

  proLike(doctorId) {
    console.log("doc ID=>", doctorId);
    this.particularDocterPro.favourite = !this.particularDocterPro.favourite;
    let apiData = JSON.stringify({
      "doctorId": doctorId,
      "patientId": localStorage.getItem("patient_id"),
      "favourite": this.particularDocterPro.favourite
    });
    console.log("send favrit Reqst=>", JSON.parse(apiData));
    this.services.postRequest("favouriteDoctorAddingandRemoving", apiData).subscribe(res => {
      console.log(res);
    });
    if (this.particularDocterPro.favourite == true) {
      this.toastMessage = "Add to Favourite";
      this.presentToast()
    }
    else if (this.particularDocterPro.favourite == false) {
      this.toastMessage = "Removed from Favourite";
      this.presentToast()
    }
  }

  showRow1(i) {
    if (this.showMoreSlots == i) {
      this.showMoreSlots = null;
    }
    else {
      this.showMoreSlots = i;
    }
  }

  showChApMntPopUp(slotDetails, slotFromTime) {
    this.home = false;
    this.direct = false;
    this.selectSlotFromTime = slotFromTime;

    this.storeSelectedSlot = slotDetails;//this.particularDocterPro.clinicSlotsDetails[slotIndex];
    console.log("selectedSlotDetails");
    if (this.storeSelectedSlot.appointmentTypeId == 4) {
      this.chApMntPopUpPro = true;
      this.showBkgDetail = false;
    }
    else {
      this.showBkgDetail = true;
    }
    this.storeAppointmentTypeId = this.storeSelectedSlot.appointmentTypeId;
    console.log(this.storeSelectedSlot);
    if (this.selectedService == null) {
      this.selectedService = this.storeDocServiceList[0].serviceTypeId;
    }
    console.log("service=>", this.selectedService);
  }

  selectMember(memberName, membId) {
    this.PatientName = memberName;
    this.currentMemberId = membId;
  }
  showEditNamePopUp() {
    this.editNamePpUp = !this.editNamePpUp;
  }
  showApMntQueue(index) {
    this.setQueue();
    this.positionQueue = 0;
    if (this.apMntQueue == index) {
      this.apMntQueue = null;
      console.log("same");
    }
    else {
      this.apMntQueue = index;
      console.log("Not Same");
    }

    console.log(index);
    this.profileImage = this.storeDocBookingList[index].doctorProfileImage;
    console.log("profile img", this.profileImage);
    let getDate = new Date();
    let currentDate = getDate.getFullYear() + "-" + (getDate.getMonth() + 1) + "-" + getDate.getDate();
    let currentTime = new Date().toTimeString().split(" ")[0];
    let apiData = JSON.stringify({
      "clinic_id": this.storeDocBookingList[index].clinic_id,
      "currentDate": currentDate,
      "currentTime": currentTime,
      "doctor_id": this.storeDocBookingList[index].doctor_id,
      "bookingId": this.storeDocBookingList[index].bookingId
    });
    console.log("send queue details Reqst=>", JSON.parse(apiData));
    this.services.postRequest("memberQueueDetailsForParticularBooking", apiData).subscribe(res => {
      console.log(res);
      if (res.status != 0) {
        this.positionQueue = res.data[0].queuePosition;
        for (let i = 0; i <= 4; i++) {
          if (i == (this.positionQueue - 1)) {
            this.queueList[i] = this.profileImage;
          }
        }
      }
    });
  }

  setQueue() {
    this.queueList = [];
    let item = "assets/img/persnIcon1.png";
    for (let i = 1; i <= 5; i++) {
      console.log("loop i=>", i);
      this.queueList.push(item);
    }
    console.log("queue=>", this.queueList);
  }

  showApMntAddFltrPopUp() {
    console.log("open Filter popup");
    this.pageNo = 1;
    this.EmptyData = null;
    this.checkSearchTrueOrFalse = true;
    this.apMntAddFltrPopUp = true;
    this.getFltrPatientId=null;
    this.getFltrDocId=null;
    this.getFltrFromDate=null;
    this.getFltrToDate=null;
    this.getDocPatientList();
  }
  closeApMntAddFltrPopUp() {
    console.log("close Filter popup");
    this.checkSearchTrueOrFalse = false;
    this.apMntAddFltrPopUp = false;
  }

  showReviewPopUp(docId, docImg, docName) {
    console.log("revDocDetails=>", docId, docImg, docName);
    this.getReviewPopUp = !this.getReviewPopUp;
    if (this.getReviewPopUp == true) {
      this.setRevDocImg = docImg;
      this.setRevDocName = docName;
      this.setRevDocId = docId;
    }
  }


  checkVideo(id, index, Sindex) {
    var video = document.getElementById(id);
    var d = this;
    video.onended = function () {
      //this.videoFinished(id);
      console.log(d.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode);
      d.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode = false;
    };

    console.log("Id", id);
  }
  onIntersection($event, id, index, Sindex) {
    const { [InViewportMetadata]: { entry }, target } = $event;
    const ratio = entry.intersectionRatio;
    const vid = target;
    if ($event.visible == false) {
      console.log("Event", $event.target.autoplay);
      $event.target.autoplay = false;
      console.log("Event2", $event.target.autoplay);
    }
    console.log("play Video Event=>", $event);
    if (ratio >= 0.85) {
      console.log("Play Video Details=>", id, index, Sindex);
      var playPromise = vid.play();

      if (playPromise !== undefined) {
        playPromise.then(_ => {
          console.log("notError so Play");
          vid.play();
          console.log(this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode);
          this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode = true;
          this.checkVideo(id, index, Sindex);
        })
          .catch(error => {
            console.log("error so Pause");
            vid.pause();
            this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode = false;
          });
      }
    } else {
      if (this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode == true) {
        console.log("executed");
        vid.pause();
        this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode = false;
      }
    }
    //ratio >= 0.85 ? vid.play() : vid.pause();
  }

  playVideo(index, vdoIn, id, value) {
    console.log("passing Data=>", index, vdoIn, id, value);
    this.playVid = document.getElementById(id);
    switch (value) {
      case 'play': {
        this.playVid.play();
        console.log("video duration=>", this.playVid.duration);
        this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].playMode = true;
        console.log(this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].playMode);
        break;
      }
      case 'pause': {
        this.playVid.pause();
        this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].playMode = false;
        console.log(this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].playMode);
        break;
      }
      case 'mute': {
        this.playVid.muted = true;
        this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].muteMode = true;
        console.log(this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].muteMode);
        break;
      }
      case 'unMute': {
        this.playVid.muted = false;
        this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].muteMode = false;
        console.log(this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].muteMode);
        break;
      }
    }
    console.log(value);
    console.log(vdoIn);
  }

  playProVideo(index, id, value) {
    this.playVid = document.getElementById(id);
    switch (value) {
      case 'play': {
        if (this.currentVideoId != null) {
          this.stopPlayVideo();
        }
        this.playVid.play();
        this.profileMediaDetails[index].playMode = true;
        this.currentVideoId = id;
        this.currentVideoIndex = index;
        break;
      }
      case 'pause': {
        this.currentVideoId = null;
        this.currentVideoIndex = null;
        this.playVid.pause();
        this.profileMediaDetails[index].playMode = false;
        break;
      }
    }
    console.log("playVideo Details", id, index, this.profileMediaDetails[index].playMode);
  }

  stopPlayVideo() {
    console.log("call pause video function");
    this.playVid = document.getElementById(this.currentVideoId);
    this.playVid.pause();
    this.profileMediaDetails[this.currentVideoIndex].playMode = false;
    this.currentVideoId = null;
    this.currentVideoIndex = null;
  }

  showPlyOptn(i) {
    this.showVideoOptins = i;
    setTimeout(() => {
      this.showVideoOptins = null;
    }, 5000)
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }

    var Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        var hourEnd = Value.indexOf(":");
        var H = +String(Value).substr(0, hourEnd);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? "AM" : "PM";
        // var ampm = (H < 12 || H === 24) ? this.addCall.title458 : this.addCall.title459;
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        return timeString;
      case "Date":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  //-------------/\--------SOME SPECIAL FUNCTION'S-----------/\-------------//



  //---------------------><----------------><----------------------><--------------------------><----------------------------//



  // ---------\/---------Sorting & Filter functions-----\/-----//


  selctDctGndr(value) {
    this.pageNo = 1;
    this.EmptyData = null;
    switch (value) {
      case "Male": {
        this.Male = !this.Male;
        this.Female = false;
        if (this.Male == true) {
          this.genderStatus = true;
          this.genderContent = "male";
        }
        else {
          this.genderStatus = false;
        }
        break;
      }
      case "Female": {
        this.Female = !this.Female;
        this.Male = false;
        if (this.Female == true) {
          this.genderStatus = true;
          this.genderContent = "female";
        }
        else {
          this.genderStatus = false;
        }
        break;
      }
    }
    this.showListPhysiotherapy(this.specialityId);
    console.log(this.genderStatus, "-", this.genderContent);
  }

  screenMode(value) {
    this.pageNo = 1;
    this.EmptyData = null;
    switch (value) {
      case 'sun': {
        this.sunMode = !this.sunMode;
        this.darkMode = false;
        break;
      }
      case 'dark': {
        this.darkMode = !this.darkMode;
        this.sunMode = false;
      }
    }
    this.showListPhysiotherapy(this.specialityId);
    console.log(this.sunMode);
    console.log(this.darkMode);
  }

  costBasedSorting() {
    this.costSortingStatus = !this.costSortingStatus;
    this.pageNo = 1;
    this.EmptyData = null;
    if (this.costSortingStatus == true) {
      this.costSortingContent = "DESC";
    }
    else {
      this.costSortingContent = "ASC";
    }
    this.showListPhysiotherapy(this.specialityId);
    console.log("cost Sta :", this.costSortingStatus);
    console.log("cost Cont :", this.costSortingContent);
  }

  searchDocter() {
    this.searchStatus = true;
    this.pageNo = 1;
    this.EmptyData = null;
    this.showListPhysiotherapy(this.specialityId);
    console.log(this.searchStatus);
    console.log(this.SearchContent);
  }
  searchDocDateBase() {
    this.searchDate = this.getSearchDate.split("T")[0];
    console.log(this.searchDate);
    this.pageNo = 1;
    this.EmptyData = null;
    this.showListPhysiotherapy(this.specialityId);
  }

  async openDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': this.selectedDate,
        'calenderType': "normal"    //normal/dob
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log(data);
        if (data.data) {
          // this.selectedDate = data.data;
          //this.searchDate = data.data.toISOString().split("T")[0];
          this.Date = data.data
          this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
          this.pageNo = 1;
          this.EmptyData = null;
          console.log(this.searchDate);
          this.storePhysiotherapyDocList = [];
          this.showListPhysiotherapy(this.specialityId);
        }
        console.log("selectedDate=>", this.searchDate);
      });
  }

  async openDatePicker2() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': this.selectedDate,
        'calenderType': "dob"    //normal/dob
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log(data);
        if (data.data) {
          this.Dob = data.data
          this.membDOB = this.getFormattedDateTime(this.Dob, "Date");
          this.getMemDob = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
        }
        console.log("selectedDate=>", this.getMemDob);
      });
  }

  async proOpenDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': this.selectedDate,
        'calenderType': "normal"    //normal/dob
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log(data);
        if (data.data) {
          // this.selectedDate = data.data;
          this.Date = data.data
          this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
          // this.getDocDetails();
          this.getSlots();
        }
        console.log("selectedDate=>", this.selectedDate);
      });
  }

  async advanceFilterDatePicker(fromOrTo) {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': this.selectedDate,
        'calenderType': "normal"    //normal/dob
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log(data);
        if (data.data && fromOrTo == "from") {
          let Date = data.data;
          this.getFltrFromDate = this.getFormattedDateTime(Date, "Date");
          // this.getFltrFromDate = Date.getFullYear() + "-" + ("0"+(Date.getMonth() + 1)).slice(-2) + "-" +("0"+Date.getDate()).slice(-2);
        }
        else if (data.data && fromOrTo == "to") {
          let Date = data.data;
          this.getFltrToDate = this.getFormattedDateTime(Date, "Date");
          // this.getFltrToDate = Date.getFullYear() + "-" + ("0"+(Date.getMonth() + 1)).slice(-2) + "-" +("0"+Date.getDate()).slice(-2);
        }
        console.log("selectedDate=>", this.selectedDate);
      });
  }

  dateIncDec(incOrDec) {
    if (incOrDec == 'inc') {
      let date = null;
      date = new Date(this.Date);
      console.log("oset=>", date);
      date.setDate(date.getDate() + 1);
      this.Date = date;
      this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
      console.log("date", date);
      console.log("setDate", this.Date);
      console.log("searchDate", this.searchDate);
      this.pageNo = 1;
      this.EmptyData = null;
      this.storePhysiotherapyDocList = [];
      this.showListPhysiotherapy(this.specialityId);
    }
    else if (incOrDec == 'dec') {
      let date = null;
      date = new Date(this.Date);
      console.log("oset=>", date);
      date.setDate(date.getDate() - 1);
      this.Date = date;
      this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
      console.log("date", date);
      console.log("setDate", this.Date);
      console.log("searchDate", this.searchDate);
      this.pageNo = 1;
      this.EmptyData = null;
      this.storePhysiotherapyDocList = [];
      this.showListPhysiotherapy(this.specialityId);
    }
  }

  dateIncDecPro(incOrDec) {
    if (incOrDec == 'inc') {
      let date = null;
      date = new Date(this.Date);
      console.log("oset=>", date);
      date.setDate(date.getDate() + 1);
      this.Date = date;
      this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
      console.log("date", date);
      console.log("setDate", this.Date);
      console.log("searchDate", this.searchDate);

      // this.showphysiotherapyPro(this.storeDocListIndex, this.storeBookOrRescheFlowValue);
      //this.getSlots();
      this.showBkgDetail = false;
      this.selectSlotFromTime = null;
      this.getParticularDocDetails();
    }
    else if (incOrDec == 'dec') {
      let date = null;
      date = new Date(this.Date);
      console.log("oset=>", date);
      date.setDate(date.getDate() - 1);
      this.Date = date;
      this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
      console.log("date", date);
      console.log("setDate", this.Date);
      console.log("searchDate", this.searchDate);
      // this.showphysiotherapyPro(this.storeDocListIndex, this.storeBookOrRescheFlowValue);
      //this.getSlots();
      this.showBkgDetail = false;
      this.selectSlotFromTime = null;
      this.getParticularDocDetails();
    }
  }


  chooseAppmnt(value) {
    if (value == 'home') {
      this.showBkgDetail = true;
      this.home = !this.home;
      this.direct = false;
      this.appoinmentType = "In House";
      this.storeAppointmentTypeId = 5;
    }
    else {
      this.showBkgDetail = true;
      this.direct = !this.direct;
      this.home = false;
      this.appoinmentType = "Direct";
      this.storeAppointmentTypeId = 1;
    }
    setTimeout(() => {
      this.chApMntPopUpPro = false;
    }, 1000);
  }



  // --------/\----------Sorting & Filter functions-----/\-----//



  ionViewWillEnter() {
    switch (localStorage.getItem("NopayGoBack")) {
      case "newEnter": {
        this.showListCatPage();
        break;
      }
      case "BookingConPage": {
        this.showBookingConPage();
        break;
      }
      case "ReschedulePage": {
        this.showAppointmentListPage();
        break;
      }
      default: {
        this.showListCatPage();
      }
    }
  }

  showListCatPage() {
    this.presentView = "listCategory";
    this.backValue = "goHome";
    this.headerValue = null;//"PhysioTheraby";
    this.placeholderValue = "Search";
    this.specialityList = null;
    this.storePhysiotherapyDocList = [];
    this.pageNo = 1;
    this.EmptyData = null;
    this.showBkgDetail = false;
    this.selectSlotFromTime = null;
    this.services.getRequest("getPhysioSpeciality").subscribe(res => {
      console.log(res);
      this.specialityList = res.data;
      console.log(this.specialityList);
      // this.storeRefreshEvent.target.complete();
    });
    let getDate = new Date();
    this.searchDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + getDate.getDate()).slice(-2);
    console.log("searchDate=>", this.searchDate);
    this.Date = new Date();
    this.sunMode = true;
    this.darkMode = false;
    if (localStorage.getItem("Gender") == "male" || localStorage.getItem("Gender") == "Male") {
      this.Male = true;
      this.Female = false;
      this.genderStatus = true;
      this.genderContent = "male";
    }
    else {
      this.Male = false;
      this.Female = true;
      this.genderStatus = true;
      this.genderContent = "female";
    }
  }



  //new api
  showListPhysiotherapy(splId) {
    this.nextCount = 0;
    this.showBkgDetail = false;
    this.selectSlotFromTime = null;
    this.specialityId = splId;
    console.log("splID=>", this.specialityId);
    this.showAll1 = false;
    this.presentView = "listPhysiotherapy";
    // this.placeholderValue = "jebriya,Kuwaith";
    this.backValue = "goCatPage";
    this.headerValue = null;//"PhysioTheraby";
    console.log("searchDate=>", this.searchDate);
    let getDate = new Date();
    this.curntDate = getDate.getFullYear() + "-" + (getDate.getMonth() + 1) + "-" + getDate.getDate();
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "doctorGenderChecking": this.genderStatus,
      "doctorGender": this.genderContent,
      "currentDate": this.curntDate,
      "searchDate": this.searchDate,
      "day": this.sunMode,
      "night": this.darkMode,
      "lat": "8.307531",
      "long": "77.221832",
      "costBasedSorting": this.costSortingStatus,
      "costBasedSortingOrder": this.costSortingContent,
      "speciality": true,
      "specialityId": this.specialityId,
      "advanceFilter": this.advanceFilterStatus,
      "advanceFilterCost": this.advanceFilterCost,
      "advanceFilterOffers": this.advanceFilterOffers,
      "advanceFilterDistance": this.advanceFilterDistance,
      "limit": 3,
      "pageno": this.pageNo,
      "typeSearch": this.searchStatus,
      "typeSearchContent": this.SearchContent,
      "current_time": new Date().toTimeString().split(" ")[0]
    });
    console.log("send physiotheraby List Reqst=>22", JSON.parse(apiData));
    this.services.postRequest("patientPhysioSearch", apiData).subscribe(res => {
      console.log(res);
      if (res.status != 0) {
        this.nextCount = res.data[0].nextCount;
        console.log("nextCount", this.nextCount);
      }
      if (this.pageNo != 1) {
        this.EmptyData = res.status;
        console.log("EmtyData=", this.EmptyData);
        for (let item of res.data[0].details) {
          for (let item2 of item.mediaDetails) {
            let convert = JSON.stringify(this.videoOptions);
            this.videoOptions = JSON.parse(convert);
            item2['playVideOpt'] = this.videoOptions;
          }
          this.storePhysiotherapyDocList.push(item);
        }
        console.log("added Lst", this.storePhysiotherapyDocList);
        console.log("Page No:", this.pageNo);
      }
      else {
        this.storePhysiotherapyDocList = [];
        this.EmptyData = res.status;
        console.log("EmtyData=", this.EmptyData);
        this.EmptyData = res.status;
        console.log("EmtyData=", this.EmptyData);
        for (let item of res.data[0].details) {
          for (let item2 of item.mediaDetails) {
            let convert = JSON.stringify(this.videoOptions);
            this.videoOptions = JSON.parse(convert);
            item2['playVideOpt'] = this.videoOptions;
          }
          this.storePhysiotherapyDocList.push(item);
        }
        console.log("added Lst", this.storePhysiotherapyDocList);
        console.log("Page No:", this.pageNo);


        // for (let item of res.data[0].details) {
        //   if (item.mediaDetails != null) {
        //     for (let item2 of item.mediaDetails) {
        //       var just = item2['playVideOpt'] = this.videoOptions;
        //     }
        //   }
        //   this.DoctorsList.push(item);
        // }

        var convert = JSON.stringify(this.storePhysiotherapyDocList);
        this.storePhysiotherapyDocList = JSON.parse(convert);
        console.log("first Enter", this.storePhysiotherapyDocList);
        console.log("Page No:", this.pageNo);
      }
    });
    this.searchStatus = false;
    this.advanceFilterStatus = false;
  }

  selectListSlot(listIndex, slotDetails) {
    this.storePhysioListIndex = listIndex;
    this.selectSlotFromTime = slotDetails.fromTime;

    this.storeSelectedSlot = slotDetails;//this.particularDocterPro.clinicSlotsDetails[slotIndex];
    console.log("selectedSlotDetails");
    if (this.storeSelectedSlot.appointmentTypeId == 4) {
      this.chApMntPopUpList = true;
      this.showBkgDetail = false;
    }
    else {
      this.showBkgDetail = true;
      this.storeAppointmentTypeId = this.storeSelectedSlot.appointmentTypeId;
      this.showphysiotherapyPro(this.storePhysioListIndex, "newBook");
    }

  }

  chooseAppmntListSlotPopUp(value) {
    if (value == 'home') {
      this.showBkgDetail = true;
      this.home = !this.home;
      this.direct = false;
      this.appoinmentType = "In House";
      this.storeAppointmentTypeId = 5;
    }
    else {
      this.showBkgDetail = true;
      this.direct = !this.direct;
      this.home = false;
      this.appoinmentType = "Direct";
      this.storeAppointmentTypeId = 1;
    }
    setTimeout(() => {
      this.chApMntPopUpList = false;
      this.showphysiotherapyPro(this.storePhysioListIndex, "newBook");
    }, 1000);
  }

  showphysiotherapyPro(index, flowValue) {
    this.presentView = "physiotherapyProPage";
    //this.showBkgDetail = false;
    // this.selectSlotFromTime = null;
    this.home = false;
    this.direct = false;
    this.chApMntPopUpPro = false;
    this.editNamePpUp = false;
    this.storeDocListIndex = index;
    this.storeBookOrRescheFlowValue = flowValue;
    if (flowValue == "newBook") {
      this.backValue = "goListPhysioPage";
      this.getPatientBasicDetails();
      this.storeDocterId = this.storePhysiotherapyDocList[index].doctorId;
      this.storeClinicId = this.storePhysiotherapyDocList[index].clinicId;
      console.log(this.selectedService);
      console.log(this.storeDocterId,
        this.storeClinicId,
        this.searchDate,
        this.selectedService);
    }
    else if (flowValue == "reSchedule") {
      this.backValue = "goAppMntPage";
      this.headerValue = null;
      this.showBkgDetail = false;
      this.selectSlotFromTime = null;
      this.storeDocterId = this.storeDocBookingList[index].doctor_id;
      this.storeClinicId = this.storeDocBookingList[index].clinic_id;
      this.searchDate = this.storeDocBookingList[index].book_date.split("T")[0];
      this.selectedService = this.storeDocBookingList[index].service_type_id;
      this.PatientName = this.storeDocBookingList[index].patientName;
      this.currentMemberId = this.storeDocBookingList[index].patient_id;
      this.rescheduledIsMember = this.storeDocBookingList[index].is_member;
      this.oldBookingId = this.storeDocBookingList[index].bookingId;
      this.doctorServiceFees = this.storeDocBookingList[index].book_amount;
      console.log("DocFees=>", this.doctorServiceFees);
      console.log(this.storeDocterId,
        this.storeClinicId,
        this.searchDate,
        this.selectedService,
        this.oldBookingId);
    }
    console.log("Index=>", this.storeDocListIndex);
    console.log("flowVAlue", this.storeBookOrRescheFlowValue);
    this.getDocServiceList();
    this.getParticularDocDetails();
  }
  getParticularDocDetails() {
    this.particularDocterPro = null;
    let apiData = JSON.stringify({
      "doctorId": this.storeDocterId,
      "clinicId": this.storeClinicId,
      "lat": "8.331080",
      "long": "77.172989",
      "currentDate": new Date().toISOString().split("T")[0],
      "patientId": localStorage.getItem("patient_id"),
      "searchDate": this.searchDate,
      "current_time": new Date().toTimeString().split(" ")[0]
    });
    console.log("sent perclr Doc Details=>", JSON.parse(apiData));
    this.services.postRequest("particularPhysioDetails", apiData).subscribe(res => {
      console.log(res);
      this.particularDocterPro = res.data[0];
      for (let item of this.particularDocterPro.mediaDetails) {
        console.log("item=>", item);
        var add = item['playMode'] = false;
        console.log("item=>", add);
        console.log("item=>", item);
        this.profileMediaDetails.push(item);
      }
      console.log("prtclrDocDet", this.particularDocterPro);
      // this.getReviewCommands = JSON.parse(this.particularDocterPro.review_comment);
      console.log("particular Doc Details=>", this.particularDocterPro);
      this.headerValue = this.particularDocterPro.vendor_name;
    });
    // this.getSlots();
    // this.getMedia();
  }

  getSlots() {
    this.storeSlots = [];
    this.particularDocterPro.clinicSlotsDetails = null;
    let apiData = JSON.stringify({
      "day": true,
      "doctorId": Number(this.storeDocterId),
      "clinicId": this.storeClinicId,
      "searchDate": this.searchDate,
      "current_time": new Date().toTimeString().split(" ")[0]
    });
    console.log("send get slot Request=>", JSON.parse(apiData));
    this.services.postRequest("particularPhysioSlotsBasedonDate", apiData).subscribe(res => {
      console.log("slots details", res);
      this.storeSlots = res.data;
      this.particularDocterPro.clinicSlotsDetails = res.data;
      console.log("storeSlots=>", this.storeSlots);
    });
  }

  getMedia() {
    this.profileMediaDetails = [];
    let apiData2 = JSON.stringify({
      "doctorId": Number(this.storeDocterId),
      "limit": 3,
      "pageno": 1
    });
    this.services.postRequest("getMediaDetailsByDoctor", apiData2).subscribe(res => {
      console.log("mediaDetails=>", res);
      for (let item of res.data[0].details) {
        console.log("item=>", item);
        var add = item['playMode'] = false;
        console.log("item=>", add);
        console.log("item=>", item);
        this.profileMediaDetails.push(item);
      }
      let convert = JSON.stringify(this.profileMediaDetails);
      this.profileMediaDetails = JSON.parse(convert);
      console.log("Media Details=>", this.profileMediaDetails);
    });
  }
  getPatientBasicDetails() {
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "currentTime": new Date().toTimeString().split(" ")[0]
    });
    console.log("send patient Basic Reqst=>", JSON.parse(apiData));
    this.services.postRequest("getPatientProfile", apiData).subscribe(res => {
      console.log(res);
      this.patientBasicDetails = res.data[0];
      this.PatientName = this.patientBasicDetails.name;
      this.currentMemberId = localStorage.getItem("patient_id");
    });
  }

  getDocServiceList() {
    let apiData = JSON.stringify({
      "doctorId": Number(this.storeDocterId),
    });
    this.services.postRequest("doctorServiceDropDown", apiData).subscribe(res => {
      console.log(res);
      this.storeDocServiceList = res.data.details;
      this.selectedService = String(this.storeDocServiceList[0].serviceTypeId);
      this.doctorServiceFees = this.storeDocServiceList[0].total;
      console.log("doctServFees=>", this.doctorServiceFees);
      this.serviceDuration = {
        hr: Math.floor(this.storeDocServiceList[0].duration / 60),
        min: this.storeDocServiceList[0].duration % 60
      }
      console.log("DropDown=>", this.storeDocServiceList);
      console.log(this.selectedService);
    })
  }
  typesOfServices() {
    for (let item of this.storeDocServiceList) {
      if (item.serviceTypeId == this.selectedService) {
        this.serviceDuration = {
          hr: Math.floor(item.duration / 60),
          min: item.duration % 60
        }
        this.doctorServiceFees = item.total;
        console.log("doctServFees=>", this.doctorServiceFees);
        // this.serviceDuration =item.duration;
      }
    }

    console.log("serviceDuration=>", this.serviceDuration);
    console.log("serviceId=>", this.selectedService);
  }

  showBookingConPage() {
    this.presentView = "bookingConPage";
    this.backValue = "goPhysioProPage";
    this.headerValue = "Booking Confirmation";
    if (this.appoinmentType == 'In House') {
      this.payBtnValue = "Proceed";
    }
    else {
      this.payBtnValue = "Proceed to Pay";
    }
  }
  addMemberPage() {
    this.presentView = "addMemberPage";
    this.backValue = "goPhysioProPage";
    this.headerValue = "Add Member";
    this.getPatientReletion();
    this.getMemName = null;
    this.getMemGender = null;
    this.getMemReletion = null;
    this.getMemHeight = null;
    this.getMemWeight = null;
    this.getMemMobileNo = null;
    this.membDOB = null;
    this.getMemDob = null;
  }

  getPatientReletion() {
    this.services.getRequest("getpatientrelation").subscribe(res => {
      console.log(res);
      this.reletionList = res.data;
      console.log("reletionList=>", this.reletionList);
    });
  }




  insertMemberDetails() {
    console.log(this.getMemName,
      this.getMemGender,
      this.getMemReletion,
      this.getMemHeight,
      this.getMemWeight,
      this.getMemMobileNo,
      this.getMemDob);
    if (this.getMemName != null &&
      this.getMemGender != null &&
      this.getMemReletion != null &&
      this.getMemHeight != null &&
      this.getMemWeight != null &&
      this.getMemMobileNo != null &&
      this.getMemDob != null) {
      this.insertMember();
    }
    else {
      let value = [
        {
          "f_Name": "Enter Name",
          "f_value": this.getMemName
        },
        {
          "f_Name": "Choose Gender",
          "f_value": this.getMemGender
        },
        {
          "f_Name": "Select Date Of Birth",
          "f_value": this.getMemDob
        },
        {
          "f_Name": "Choose Reletion",
          "f_value": this.getMemReletion
        },
        {
          "f_Name": "Enter Height",
          "f_value": this.getMemHeight
        },
        {
          "f_Name": "Enter Weight",
          "f_value": this.getMemWeight
        }, {
          "f_Name": "Enter Mobile No",
          "f_value": this.getMemMobileNo
        }];
      console.log("Value=>", value);
      for (let item of value) {
        if (item.f_value == null) {
          this.toastMessage = "please " + item.f_Name;
          this.presentToast();
          break;
        }
      }
    }
  }



  insertMember() {
    this.presentLoading();
    let apiData = JSON.stringify({
      "parentpatientId": localStorage.getItem("patient_id"),
      "patientId": 0,
      "name": this.getMemName,
      "gender": this.getMemGender,
      "dob": this.getMemDob,         //"11/11/97"
      "relationId": this.getMemReletion,
      "heightcm": this.getMemHeight,
      "weightkg": this.getMemWeight,
      "phoneno": this.getMemMobileNo,
      "modifiedby": localStorage.getItem("patient_id")
    });
    console.log("send Member Data=>10", JSON.parse(apiData));
    this.services.postRequest("addPatientmemberDetails", apiData).subscribe(res => {
      console.log(res);
      if (res.status == 1) {
        setTimeout(() => {
          this.loadingController.dismiss();
        }, 500);

        this.AlertInfo("Member added successfully", res.status);
        this.presentView = "physiotherapyProPage";
        this.backValue = "goListPhysioPage";
        this.showBkgDetail = true;
        this.getPatientBasicDetails();
      }
      else {
        setTimeout(() => {
          this.loadingController.dismiss();
        }, 500);
        // this.toastMessage = res.msg;
        // this.presentToast();
      }
    });
  }

  goToPayment() {
    this.addBooking();
  }
  goToPaymentReschedule() {
    localStorage.setItem("payBack", "physiotherapy");
    localStorage.setItem("Reschedule", "ReschedulePage");
    this.rescheduleBooking();
  }

  addBooking() {
    this.presentLoading();
    let isMember;
    let tempName;
    console.log("PatientName=>", this.PatientName);
    console.log("patient_name=>", localStorage.getItem("patient_name"));
    for (let item of this.patientBasicDetails.patientmemberDetails) {
      if (item.name == this.PatientName || localStorage.getItem("patient_name") == this.PatientName) {
        isMember = 1;
        tempName = null;
        console.log("isMember");
        if (item.name == this.PatientName) {
          this.currentMemberId = item.PatientMemberId;
          console.log("MemberpatientId=>", this.currentMemberId);
        }
        else {
          console.log("ParentpatientId=>", this.currentMemberId);
          this.currentMemberId = localStorage.getItem('patient_id');
        }
        break;
      }
      else {
        isMember = 2;
        tempName = this.PatientName;
        this.currentMemberId = localStorage.getItem("patient_id");
        console.log("isNotMember");
      }
    }
    let apiData = JSON.stringify({
      "doctorId": this.particularDocterPro.doctorId,
      "patientId": this.currentMemberId,//localStorage.getItem("patient_id"),
      "clinicId": this.particularDocterPro.clinicId,
      "serviceTypeId": this.selectedService,
      "bookeDate": this.searchDate,
      "fromTime": this.storeSelectedSlot.fromTime,
      "toTime": this.storeSelectedSlot.toTime,
      "totalSlots": "1",
      "isVIP": "0",
      "amount": this.doctorServiceFees,//this.particularDocterPro.amount,
      "paymentStatus": "1",
      "appointmentTypeId": this.storeAppointmentTypeId,
      "appointmentTypeIsChangable": 1,
      "isMember": isMember,
      "tempMemberName": tempName,//this.PatientName,
      "oldBookingId": "0"
    });
    console.log("send add booking Reqst=>16", JSON.parse(apiData));
    this.services.postRequest("patientPhysioBooking", apiData).subscribe(res => {
      console.log(res);
      if (res.status == 1) {
        this.loadingController.dismiss();
        localStorage.setItem("payBack", "physiotherapy");
        this.router.navigate(['payment']);
      }
      else {
        this.loadingController.dismiss();
      }
    });
  }

  rescheduleBooking() {
    this.presentLoading();
    let apiData = JSON.stringify({
      "oldBookingId": this.oldBookingId,
      "doctorId": this.particularDocterPro.doctorId,
      "patientId": this.currentMemberId,//localStorage.getItem("patient_id"),
      "clinicId": this.particularDocterPro.clinicId,
      "serviceTypeId": this.selectedService,
      "bookeDate": this.searchDate,
      "fromTime": this.storeSelectedSlot.fromTime,
      "toTime": this.storeSelectedSlot.toTime,
      "totalSlots": "1",
      "isVIP": "0",
      "amount": this.doctorServiceFees,//this.particularDocterPro.amount,
      "paymentStatus": "1",
      "appointmentTypeId": this.storeAppointmentTypeId,
      "appointmentTypeIsChangable": 1,
      "isMember": this.rescheduledIsMember,
      "tempMemberName": this.PatientName
    });
    console.log("send Reschedule Data Reqst=>", JSON.parse(apiData));
    this.services.postRequest("reschedulePhysioAppointment", apiData).subscribe(res => {
      console.log(res);
      if (res.status == 1) {
        this.loadingController.dismiss();
        localStorage.setItem("payBack", "physiotherapy");
        this.router.navigate(['payment']);
      }
      else {
        this.loadingController.dismiss();
      }
    });
  }

  bookingListPage() {
    this.pageNo = 1;
    this.EmptyData = null;
    this.storeDocBookingList = [];
    this.showAppointmentListPage();
  }
  bookingHisPage() {
    this.pageNo = 1;
    this.EmptyData = null;
    this.bookingHisList = [];
    this.showHistoryPage();
  }

  showAppointmentListPage() {
    this.nextCount = 0;
    this.presentView = "appointmentPage";
    this.apMntAddFltrPopUp = false;
    this.backValue = "goCatPage";
    this.headerValue = "Appoinments";
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      // "current_time": new Date().toTimeString().split(" ")[0],
      "pageno": this.pageNo,
      "limit": 10
    });
    console.log("send Booking list Reqst=>", JSON.parse(apiData));
    this.services.postRequest("patientPhysioBookedAppointmentList", apiData).subscribe(res => {
      console.log(res);
      if (res.status != 0) {
        this.nextCount = res.data[0].nextCount;
        console.log("nextCount", this.nextCount);
      }
      if (this.pageNo != 1) {
        for (let item of res.data[0].details) {
          item.clinicDetails = JSON.parse(item.clinicDetails);
          this.storeDocBookingList.push(item);
        }
        console.log("added LIst", this.storeDocBookingList);
        console.log("Page No:", this.pageNo);
      }
      else {
        this.EmptyData = res.status;
        this.storeDocBookingList = [];
        for (let item of res.data[0].details) {
          item.clinicDetails = JSON.parse(item.clinicDetails);
          this.storeDocBookingList.push(item);
        }
        console.log("first Enter", this.storeDocBookingList);
        console.log("Page No:", this.pageNo);
      }
      // this.storeRefreshEvent.target.complete();
    });
    this.setQueue();
  }

  showHistoryPage() {
    this.nextCount = 0;
    this.presentView = "historyPage";
    this.backValue = "goAppMntPage";
    this.headerValue = "Booking History";
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "limit": 10,
      "pageno": this.pageNo
    });
    console.log("send booking His List Reqst=>", JSON.parse(apiData));
    this.services.postRequest("physioBookedAppointmentHistoryList", apiData).subscribe(res => {
      console.log(res);
      if (res.status != 0) {
        this.nextCount = res.data[0].nextCount;
        console.log("nextCount", this.nextCount);
      }
      if (this.pageNo != 1) {
        for (let item of res.data[0].details) {
          this.bookingHisList.push(item);
        }
        console.log("added LIst", this.bookingHisList);
        console.log("Page No:", this.pageNo);
      }
      else {
        this.EmptyData = res.status;
        this.bookingHisList = [];
        this.bookingHisList = res.data[0].details;
        console.log("first Enter", this.bookingHisList);
        console.log("Page No:", this.pageNo);
      }
      // this.storeRefreshEvent.target.complete();
    });

  }
  showHistoryInfo(index) {
    this.presentView = "viewBookingHisInfoPage";
    this.backValue = "goHisPage";
    this.headerValue = "View Booking History";
    this.bookingHisDetails = this.bookingHisList[index];
    console.log(this.bookingHisDetails);
  }

  // reFundOption(bookingId) {
  //   this.storeBookingId = bookingId;
  //   this.showRefundPopUp = !this.showRefundPopUp;
  // }

  async cancelBkg(bookingId, bookingAmnt) {
    this.storeBookingId = bookingId;
    this.bookingAmnt = bookingAmnt;
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt
      },
    });
    modal.onDidDismiss()
      .then((data) => {
        const res = data;
        console.log(res);
        if (res.data != null) {
          console.log(res.data);
          console.log("booking id=>", res.data.bookingId);
          console.log("booking amnt=>", res.data.bookingAmnt);
          this.pageNo = 1;
          this.EmptyData = null;
          this.storeDocBookingList = [];
          this.callCancelBkgApi();
          // this.patientBookedAppointmentList();
        }
      });
    return await modal.present();
  }
  callCancelBkgApi() {
    console.log(this.storeBookingId);
    let apiData = JSON.stringify({
      "bookingId": this.storeBookingId,
      "patientId": localStorage.getItem("patient_id")
      // "cancel_time": new Date().toLocaleTimeString()
    });
    console.log("send refund Reqst=>", JSON.parse(apiData));
    this.services.postRequest("cancelPhysioAppointment", apiData).subscribe(res => {
      console.log(res);
      if (res.ststus != 0) {
        this.showAppointmentListPage();
        this.AlertInfo("Canceled Successfully", res.status);
      }
      else {
        // this.toastMessage = "Booking Cancel Failed";
        // this.presentToast();
        this.AlertInfo("Canceled Successfully", res.status);
        this.showAppointmentListPage();
      }
    });
  }

  getDocPatientList() {
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
    });
    console.log("send advance filter Patient List Reqst=>", JSON.parse(apiData));
    this.services.postRequest("advanceFilterPhysioList", apiData).subscribe(res => {
      console.log(res);
      this.storeFilterDocList = res.data;
      console.log("doctLIst=>", this.storeFilterDocList);
    });
    this.services.postRequest("advanceFilterPhysioPatientList", apiData).subscribe(res => {
      console.log(res);
      this.storeFilterPatientList = res.data;
      console.log("patientLIst=>", this.storeFilterPatientList);
    });
  }

  searchApnMnt() {
    this.nextCount = 0;
    let getFromDate;
    let getToDate;
    if (this.getFltrFromDate != null && this.getFltrToDate != null) {
      let date = new Date(this.getFltrFromDate);
      getFromDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
      let date2 = new Date(this.getFltrToDate);
      getToDate = date2.getFullYear() + "-" + ("0" + (date2.getMonth() + 1)).slice(-2) + "-" + ("0" + date2.getDate()).slice(-2);
    }
    else {
      getFromDate = null;
      getToDate = null;
    }

    console.log(this.getFltrFromDate, "--", getFromDate);
    console.log(this.getFltrToDate, "--", getToDate);
    this.storeDocBookingList = [];
    this.bookingHisList = [];
    this.EmptyData = null;
    setTimeout(() => {
      this.apMntAddFltrPopUp = false;
    }, 1000);
    let apiData = JSON.stringify({
      "pageno": this.pageNo,
      "limit": 10,
      "patientId": this.getFltrPatientId,
      "fromDate": getFromDate,//this.getFltrFromDate.split("T")[0],
      "toDate": getToDate,//this.getFltrToDate.split("T")[0],
      "doctorId": this.getFltrDocId,
    });
    console.log("send Search apmnt List Reqest=>", JSON.parse(apiData));
    this.services.postRequest("physioAppointmentAdvancedFilter", apiData).subscribe(res => {
      console.log(res);
      if (res.status != 0) {
        this.nextCount = res.data[0].nextCount;
        console.log("nextCount", this.nextCount);
      }
      if (this.presentView == 'appointmentPage') {
        if (this.pageNo != 1) {
          for (let item of res.data[0].details) {
            item.clinicDetails = JSON.parse(item.clinicDetails);
            this.storeDocBookingList.push(item);
          }
          console.log("added LIst", this.storeDocBookingList);
          console.log("Page No:", this.pageNo);
        }
        else {
          this.EmptyData = res.status;
          this.storeDocBookingList = []
          // this.storeDocBookingList = res.data[0].details;
          for (let item of res.data[0].details) {
            item.clinicDetails = JSON.parse(item.clinicDetails);
            this.storeDocBookingList.push(item);
          }
          console.log("first Enter", this.storeDocBookingList);
          console.log("Page No:", this.pageNo);
        }
        console.log("bookingList");
      }
      else if (this.presentView == "historyPage") {
        if (this.pageNo != 1) {
          for (let item of res.data[0].details) {
            this.bookingHisList.push(item);
          }
          console.log("added LIst", this.bookingHisList);
          console.log("Page No:", this.pageNo);
        }
        else {
          this.EmptyData = res.status;
          this.bookingHisList = [];
          this.bookingHisList = res.data[0].details;
          console.log("first Enter", this.bookingHisList);
          console.log("Page No:", this.pageNo);
        }
        console.log("History List");
      }
    });
  }

  getReview() {
    console.log("str Rating=>", this.getStrRating);
    let apiData = JSON.stringify({
      "doctorId": this.setRevDocId,
      "patientId": localStorage.getItem("patient_id"),
      "value": this.getStrRating,
      "remarks": this.getRemark
    });
    console.log("send Review=>", JSON.parse(apiData));
    this.services.postRequest("updateDoctorReview", apiData).subscribe(res => {
      console.log(res);
      if (res.status == 1) {
        this.toastMessage = res.msg;
        this.presentToast();
        this.getReviewPopUp = false;
        this.getRemark = null;
      };
    });
  }




  // ----------------------BACK FLOW ONLY----------------------//

  goBack(Value) {
    switch (Value) {
      case 'goHome': {
        this.router.navigate(['tabs/home']);
        break;
      }
      case 'goCatPage': {
        this.showListCatPage();
        break;
      }
      case 'goListPhysioPage': {
        this.pageNo = 1;
        this.EmptyData = null;
        this.storePhysiotherapyDocList = [];
        this.showListPhysiotherapy(this.specialityId);
        break;
      }
      case 'goPhysioProPage': {
        console.log("profileFlow", this.storeBookOrRescheFlowValue);
        if (this.storeBookOrRescheFlowValue == "newBook") {
          this.presentView = "physiotherapyProPage";
          this.backValue = "goListPhysioPage";
          this.chApMntPopUpPro = false;
          this.editNamePpUp = false;

        }
        else if (this.storeBookOrRescheFlowValue == "reSchedule") {
          this.presentView = "physiotherapyProPage";
          this.backValue = "goAppMntPage";
          this.chApMntPopUpPro = false;
          this.editNamePpUp = false;
        }
        // this.showphysiotherapyPro(this.storeDocListIndex, this.storeBookOrRescheFlowValue);
        break;
      }
      case 'goAppMntPage': {
        this.pageNo = 1;
        this.EmptyData = null;
        this.storeDocBookingList = [];
        this.showAppointmentListPage();
        break;
      }
      case 'goHisPage': {
        this.pageNo = 1;
        this.EmptyData = null
        this.bookingHisList = [];
        this.showHistoryPage();
        break;
      }
    }
    this.isConfirmed = false
  }
  
  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  openTerms() {
    const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
    const params = new HttpParams().set('vendorcategory', 'Physio');
  
    this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
      .subscribe(
        response => {
          if (response && response.data && response.data.length > 0) {
            const lastIndex = response.data.length - 1;
            this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
            const decryptedData = this.decryptContent(this.terms_and_condition_file);
            console.log("Decrypted data:", decryptedData);
        
            if (!decryptedData) {
              throw new Error('Decryption failed');
            }
        
            const content = htmlToPdfmake(decryptedData);
            console.log("PDF content:", content);
        
            if (!content || !Array.isArray(content)) {
              throw new Error('Invalid content structure');
            }
        
            const documentDefinition = {
              content: content,
              styles: {
                header: { 
                  fontSize: 12,
                  bold: true,
                  margin: [40, 10, 40, 10],
                },
                footer: {
                  fontSize: 10,
                  margin: [40, 0, 40, 0],
                },
                footerText: {
                  fontSize: 10,
                },
              },
              header: (currentPage, pageCount, pageSize) => {
                const modified_on =  new Date();
                return {
                  text: ``,
                  alignment: 'left',
                  style: 'header',
                  color: '#510F30',
                  margin: [30, 40, 0, 0],
                };
              },
              footer: (currentPage, pageCount, pageSize) => {
        
                const modified_on =  new Date();
        
                return {
                  margin: [40, 40, 40, 40],
                  columns: [
                    {
                      stack: [
                        {
                          text: `Page ${currentPage}/${pageCount}`,
                          alignment: "right",
                          color: "#510F30",
                          style: "footerText",
                        },
                      ],
                    },
                  ],
                };
              },
              pageMargins: [40, 70, 40, 180],
            };
            pdfMake.createPdf(documentDefinition).getBlob(async (blob: Blob) => {
              console.log("PDF Blob:", blob);
              try {
                const localBlob = new Blob([blob], { type: 'application/pdf' });
                const fileName = `report_${new Date().getTime()}.pdf`;
                await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
                  .then((fileEntry) => {
                    console.log("File entry:", fileEntry);
                    this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
                      .then(() => console.log('File is opened'))
                      .catch(e => console.log('Error opening file', e));
                  })
                  .catch(e => console.log('Error writing file', e));
              } catch (error) {
                console.error('Error uploading file', error);
              }
            });

          } else {
            console.error('Unexpected response format:', response);
          }
        },
        error => {
          console.error('Error:', error);
        }
      );
  }
}
